@if (langList.length > 1) {
<div class="d-flex align-items-center">
	<i class="material-icons me-2">language</i>
	<form class="nav-form me-5">
		<div class="form-group pb-0 mb-0">
			<select data-testid="SUBSYS2_LANGSEL_SELECT" class="form-control custom-select" [(ngModel)]="lang"
				[ngModelOptions]="{'standalone': true}" (ngModelChange)="changeLanguage()">
				@for (lang of langList; track $index) {
				<option [attr.data-testid]="'SUBSYS2_LANGSEL_OPT_' + lang.toUpperCase()" [value]="lang">
					{{ labels()["LANGUAGE_" + lang.toUpperCase()] }}
				</option>
				}
			</select>
		</div>
	</form>
</div>
}